import * as React from 'react'
import AppProviders from 'app/AppProviders'
import Routes from 'app/Routes'

const App: React.FC = () => {
  return (
    <AppProviders>
      <Routes />
    </AppProviders>
  )
}

export default App
